<div class="flex flex-col min-h-[32rem] h-full">
    <p-panel
        [header]="'common.filter' | translate"
        toggleable="true"
        toggler="header"
        class="shrink-0"
    >
        <div
            class="border border-gray-200 dark:border-gray-700 rounded-lg bg-gray-50/70 dark:bg-gray-800/40 px-3 py-2.5"
            role="group"
            aria-labelledby="product-disposition-group-options-heading"
        >
            <div class="flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between sm:gap-4">
                <div class="flex items-center gap-2 shrink-0 min-h-9">
                    <h3
                        id="product-disposition-group-options-heading"
                        class="m-0 text-sm font-semibold leading-tight text-gray-900 dark:text-gray-100"
                    >
                        {{ 'warehouse.open-stock-view-group-options' | translate }}
                    </h3>
                    <i
                        class="fas fa-info-circle text-muted-foreground shrink-0 text-sm leading-none"
                        [pTooltip]="
                            'warehouse.open-stock-view-grouping-options-tooltip' | translate
                        "
                        tooltipPosition="top"
                    ></i>
                </div>
                <div
                    class="flex flex-wrap items-center gap-x-4 gap-y-2.5 sm:justify-end sm:gap-x-5 sm:gap-y-2 w-full sm:w-auto"
                >
                    <phx-checkbox
                        class="min-h-9"
                        [ngModel]="groupStoragePlace()"
                        (inlineChange)="groupStoragePlace.set($event)"
                        [label]="'warehouse.show-storage-place' | translate"
                    />
                    <phx-checkbox
                        class="min-h-9"
                        [ngModel]="groupRootStoragePlace()"
                        (inlineChange)="groupRootStoragePlace.set($event)"
                        [label]="'warehouse.show-root-storage-place' | translate"
                        [tooltip]="'warehouse.show-root-storage-place-tooltip' | translate"
                    />
                    <phx-checkbox
                        class="min-h-9"
                        [ngModel]="groupLot()"
                        (inlineChange)="groupLot.set($event)"
                        [label]="'warehouse.show-lot' | translate"
                    />
                    <phx-checkbox
                        class="min-h-9"
                        [ngModel]="groupSerial()"
                        (inlineChange)="groupSerial.set($event)"
                        [label]="'warehouse.show-serial' | translate"
                    />
                </div>
            </div>
        </div>
    </p-panel>

    <div class="flex-1 min-h-0 mt-2">
        <app-product-disposition-overview-list
            [fixedProductId]="productId()"
            [groupLot]="groupLot()"
            [groupStoragePlace]="groupStoragePlace()"
            [groupRootStoragePlace]="groupRootStoragePlace()"
            [groupSerial]="groupSerial()"
        />
    </div>
</div>
